import {
  forwardRef,
  ForwardRefExoticComponent,
  PropsWithoutRef,
  RefAttributes,
  type ReactNode,
} from 'react';
import ButtonAction from '../../interfaces/buttonAction';
import BreakLine from '../commons/break-line';
import NavigationFooter from '../navigation-footer';
import * as styles from './Layout.module.css';

interface LayoutProps {
  children: ReactNode;
  backButton: ButtonAction;
  nextButton: ButtonAction;
}

const Layout: ForwardRefExoticComponent<
  PropsWithoutRef<LayoutProps> & RefAttributes<HTMLDivElement>
> = forwardRef<HTMLDivElement, LayoutProps>(function ForwardedLayout(
  { children, backButton, nextButton },
  ref,
) {
  return (
    <>
      <div ref={ref} className={styles.appContainer}>
        <BreakLine />
        {children}
        <NavigationFooter backButton={backButton} nextButton={nextButton} />
      </div>
    </>
  );
});

export default Layout;
